import { ROUTES } from './routes';

export const PERMISSION_RECORDS_VIEW_ID = 69;
export const PERMISSION_RECORDS_EDIT_ID = 70;

export const PERMISSION_CODENAMES = {
  UPLOAD_FILE: 'upload_file',
  RECORD_MANAGEMENT: 'record_management',
  DOWNLOAD_RECORDS: 'download_records',
  USER_MANAGEMENT: 'user_management',
} as const;

// routes not defined here will be available to all authenticated users
// each route can have multiple permission codenames - user needs at least one to access
export const ACCESS_PERMISSIONS: Record<string, string[]> = {
  [ROUTES.UPLOAD_FILES]: [PERMISSION_CODENAMES.UPLOAD_FILE],
  [ROUTES.TEMPLATES]: [PERMISSION_CODENAMES.UPLOAD_FILE],
  [ROUTES.DOCUMENTS]: [
    PERMISSION_CODENAMES.UPLOAD_FILE,
    PERMISSION_CODENAMES.RECORD_MANAGEMENT,
  ],
  [ROUTES.DOCUMENT_DETAIL]: [
    PERMISSION_CODENAMES.UPLOAD_FILE,
    PERMISSION_CODENAMES.RECORD_MANAGEMENT,
  ],
  [ROUTES.RECORDS]: [
    PERMISSION_CODENAMES.RECORD_MANAGEMENT,
    PERMISSION_CODENAMES.DOWNLOAD_RECORDS,
  ],
  [ROUTES.USER_MANAGEMENT]: [PERMISSION_CODENAMES.USER_MANAGEMENT],
} as const;
